/**
 * Direct environment variable test
 * This file directly checks if environment variables are being loaded
 */

// Direct check without any abstraction
const directCheck = () => {
  console.log('=== DIRECT ENV CHECK ===');
  
  // Method 1: Direct process.env access
  console.log('1. Direct process.env:');
  console.log('   REACT_APP_ACCESS_KEY:', process.env.REACT_APP_ACCESS_KEY);
  console.log('   Length:', process.env.REACT_APP_ACCESS_KEY ? process.env.REACT_APP_ACCESS_KEY.length : 0);
  
  // Method 2: Through window (in case CRA puts it there)
  console.log('2. Window object:');
  console.log('   window.process:', typeof (window as any).process);
  console.log('   window.env:', typeof (window as any).env);
  
  // Method 3: Import from config
  import('../config/env').then(module => {
    console.log('3. From config/env module:');
    console.log('   ENV.ACCESS_KEY:', module.ENV.ACCESS_KEY);
    console.log('   Length:', module.ENV.ACCESS_KEY ? module.ENV.ACCESS_KEY.length : 0);
    console.log('   getAccessKey():', module.getAccessKey());
  });
  
  // Method 4: Check if it's a build issue
  console.log('4. Build check:');
  console.log('   NODE_ENV:', process.env.NODE_ENV);
  console.log('   All REACT_APP vars:', Object.keys(process.env).filter(key => key.startsWith('REACT_APP_')));
  
  console.log('=== END CHECK ===');
};

// Execute immediately
directCheck();

// Export for console use
export { directCheck };
(window as any).directEnvCheck = directCheck;